import React from 'react';

import { FormBase } from '../../Interface';
import { ResourceThreePage } from './ResourceThreePage';
import ResourceThreeReports from './ResourceThreeReports';
import { useResourceThree } from '../../../hooks/useResourceThree';

export const ResourceThreeMain = () => {
  const resourceThreeState = useResourceThree();

  return (
    <FormBase
      name="ResourceThree"
      leftPanelContent={<ResourceThreePage resourceThreeState={resourceThreeState} />}
      rightPanelContent={
        <> {!resourceThreeState.isLoading && <ResourceThreeReports resourceThreeState={resourceThreeState} />}</>
      }
    />
  );
};
